module.exports = __webpack_public_path__ + "media/mypage/images/top/sp_top-5d6b9beef8660eefc72a0d3c76950010.jpg";